const initialState = {
  structure: null,
  image: null,
  teams: {},
  teamList: null,
  initForm: false,
  editTeam: null,
  editMembers: []
}

const organization = (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_ORGANIZATION': 
      let organization = state
      action.snapshot.docs.forEach(doc => {
        if(doc.id === "structure"){
          organization.structure = JSON.parse(doc.data().json)
          organization.image = doc.data().image
        }else{
          organization.teams[doc.id] = doc.data()
        }
      })
      organization.teamList = sortTeamByStructure(organization.teams, organization.structure)
      return organization
    
    case 'CHANGE_ORGANIZATION_INIT_STATUS': 
      return {
        ...state,
        initForm: action.status
      }
    
    case 'SHOW_ORGANIZATION_EDIT_FORM': 
      return {
        ...state,
        editTeam: action.teamId,
        editMembers: action.members
      }

    case 'HIDE_ORGANIZATION_EDIT_FORM': 
      return {
        ...state,
        editTeam: null,
        editMembers: []
      }

    default: 
      return state
  }
}
const sortTeamByStructure = (teams, structure, teamList = []) => {
  Object.keys(structure).forEach(teamId => {
    if(teams[teamId].list){
      teamList.push(teamId)
    }
    if(structure[teamId] !== null){
      sortTeamByStructure(teams, structure[teamId], teamList)
    }
  })
  return teamList
}
export default organization



// WEBPACK FOOTER //
// ./src/reducers/organization.js